import Region from '@app/model/market_state/Region';


export const REGION_DATA = {
	[Region.EUROPE]: {
		name: 'Europe',
		icon: <img className="block h-4 w-auto" title="Europe" src={'/assets/img/flags/eu.svg'} alt="Europe" />,
	},
	[Region.UNITED_STATES]: {
		name: 'United States',
		icon: <img className="block h-4 w-auto" title="United States" src={'/assets/img/flags/us.svg'} alt="United States" />,
	},
	[Region.UNITED_KINGDOM]: {
		name: 'United Kingdom',
		icon: <img className="block h-4 w-auto" title="United Kingdom" src={'/assets/img/flags/uk.svg'} alt="United Kingdom" />,
	},
	[Region.GERMANY]: {
		name: 'Germany',
		icon: <img className="block h-4 w-auto" title="Germany" src={'/assets/img/flags/de.svg'} alt="Germany" />,
	},
	[Region.BULGARIA]: {
		name: 'Bulgaria',
		icon: <img className="block h-4 w-auto" title="Bulgaria" src={'/assets/img/flags/bg.svg'} alt="Bulgaria" />,
	},
	[Region.ITALY]: {
		name: 'Italy',
		icon: <img className="block h-4 w-auto" title="Italy" src={'/assets/img/flags/it.svg'} alt="Italy" />,
	},
	[Region.FRANCE]: {
		name: 'France',
		icon: <img className="block h-4 w-auto" title="France" src={'/assets/img/flags/fr.svg'} alt="France" />,
	},
	[Region.NETHERLANDS]: {
		name: 'Netherlands',
		icon: <img className="block h-4 w-auto" title="Netherlands" src={'/assets/img/flags/nl.svg'} alt="Netherlands" />,
	},
	[Region.POLAND]: {
		name: 'Poland',
		icon: <img className="block h-4 w-auto" title="Poland" src={'/assets/img/flags/pl.svg'} alt="Poland" />,
	},
	[Region.ROMANIA]: {
		name: 'Romania',
		icon: <img className="block h-4 w-auto" title="Romania" src={'/assets/img/flags/ro.svg'} alt="Romania" />,
	},
	[Region.SERBIA]: {
		name: 'Serbia',
		icon: <img className="block h-4 w-auto" title="Serbia" src={'/assets/img/flags/rs.svg'} alt="Serbia" />,
	},
	[Region.SWITZERLAND]: {
		name: 'Switzerland',
		icon: <img className="block h-3 w-auto" title="Switzerland" src={'/assets/img/flags/switzerland.svg'} alt="Switzerland" />,
	},
	[Region.AUSTRIA]: {
		name: 'Austria',
		icon: <img className="block h-4 w-auto" title="Austria" src={'/assets/img/flags/at.svg'} alt="Austria" />,
	},
	[Region.ISRAEL]: {
		name: 'Israel',
		icon: <img className="block h-3 w-auto" title="Israel" src={'/assets/img/flags/israel.svg'} alt="Israel" />,
	},
	[Region.ALBANIA]: {
		name: 'Albania',
		icon: <img className="block h-4 w-auto" title="Albania" src={'/assets/img/flags/al.svg'} alt="Albania" />,
	},
	[Region.CZECH_REPUBLIC]: {
		name: 'Czech Republic',
		icon: <img className="block h-4 w-auto" title="Czech Republic" src={'/assets/img/flags/cz.svg'} alt="Czech Republic" />,
	},
	[Region.CANADA]: {
		name: 'Canada',
		icon: <img className="block h-3 w-auto" title="Canada" src={'/assets/img/flags/canada.svg'} alt="Canada" />,
	},
	[Region.AUSTRALIA]: {
		name: 'Australia',
		icon: <img className="block h-4 w-auto" title="Australia" src={'/assets/img/flags/australia.svg'} alt="Australia" />,
	},
	[Region.SINGAPORE]: {
		name: 'Singapore',
		icon: <img className="block h-4 w-auto" title="Singapore" src={'/assets/img/flags/singapore.svg'} alt="Singapore" />,
	},
	[Region.TURKEY]: {
		name: 'Turkey',
		icon: <img className="block h-4 w-auto" title="Turkey" src={'/assets/img/flags/turkey.svg'} alt="Turkey" />,
	},
	[Region.GREECE]: {
		name: 'Greece',
		icon: <img className="block h-3 w-auto" title="Greece" src={'/assets/img/flags/greece.svg'} alt="Greece" />,
	}
}